import { z } from 'zod';

const localNavigationMenuItemSchema = z.object({
  id: z.number(),
  text: z.string(),
  description: z.string().optional(),
  icon: z.string().optional(),
  url: z.unknown().optional(),
  targetEnvironment: z.string().optional(),
  links: z.array(z.unknown()).default([]),
});

const localNavigationMenuGroupSchema = z.object({
  title: z.string(),
  items: z.array(localNavigationMenuItemSchema).default([]),
});

const localNavigationMenuResponseSchema = z.union([
  z.array(localNavigationMenuGroupSchema),
  z.object({ data: z.array(localNavigationMenuGroupSchema) }),
]);

export const localNavigationMenuSchema = localNavigationMenuResponseSchema.transform((value) =>
  Array.isArray(value) ? value : value.data
);

export type LocalNavigationMenu = z.infer<typeof localNavigationMenuSchema>;
export type LocalNavigationMenuGroup = z.infer<typeof localNavigationMenuGroupSchema>;
export type LocalNavigationMenuRawItem = z.infer<typeof localNavigationMenuItemSchema>;
